import { initializeApp, type FirebaseApp } from "firebase/app";
import {
  getFirestore,
  type Firestore,
  enableIndexedDbPersistence,
} from "firebase/firestore";

const cfg = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
};

let app: FirebaseApp | null = null;
let db: Firestore | null = null;

export function getDb(): Firestore | null {
  if (!cfg.apiKey || !cfg.projectId) {
    // Firestore disabled — local-only mode
    return null;
  }
  if (!app) {
    app = initializeApp(cfg);
    db = getFirestore(app);
    // Best-effort offline persistence
    enableIndexedDbPersistence(db).catch(() => {
      /* multi-tab or unsupported — ignore */
    });
  }
  return db;
}

// PM26: Pal Mundo Festival 2026 (za 18 juli, Almeerderstrand). Data van vorige
// events blijft in hun eigen us26-/bp26-namespaces — rules zijn per-{eventId} wildcards.
export const EVENT_ID = "pm26";
// Namespace `nexxt_cp` avoids the existing `events/{eventId}` rules in
// prepared-platform which require authenticated users. Elk event schrijft
// uitsluitend in zijn eigen sub-namespace.
export const FIRESTORE_PATH = `nexxt_cp/${EVENT_ID}`;
